export const BAY_PREFERENCES = ["INSIDE_PORT", "OUTSIDE_PORT"] as const;
export type BayPreference = (typeof BAY_PREFERENCES)[number];

export const PAYMENT_TYPES = ["MONTHLY", "YEARLY", "EXEMPTED"] as const;
export type PaymentType = (typeof PAYMENT_TYPES)[number];

// DFT-0110: which port entity a request belongs to - POF (Port of Fujairah) or POD (Port of
// Dibba). Chosen once at creation and immutable thereafter.
export const BAY_HIRE_PORTS = ["POF", "POD"] as const;
export type BayHirePort = (typeof BAY_HIRE_PORTS)[number];

export const BAY_HIRE_QUERY_KEYS = {
  requests: "bayHireRequests",
  queue: "bayHireQueue",
  request: "bayHireRequest",
  bayOptions: "bayHireBayOptions",
  myCompanyDetails: "bayHireMyCompanyDetails",
} as const;
